import { DefaultRouter } from "./default-router";
import {AuthRouter } from "./auth-router";

export const IndexRouters = [
  ...DefaultRouter,
  ...AuthRouter,
];
